<template>
  <div>
    <!-- Mobile filters -->
    <div class="md:hidden ">
      <base-button
        class="h-10 flex center b b-grey-10 rounded-xs px-6 <md:w-full space-x-2"
        @click="openFiltersPanel"
      >
        <span class="text-sm">{{ $t.filterReviews }}</span>
        <vf-icon name="filters" />
      </base-button>
    </div>
    <!-- Desktop Dropdown filters -->
    <div class="flex gap-3 wrap lg:mt-3 <md:hidden">
      <template v-for="(filter, code) in filters" :key="code">
        <vf-dropdown v-if="filter.type === 'Checkbox'" :label="filter.label">
          <filter-options
            :key="`reviewFilter-${code}`"
            :filter
            layout="grid"
            :model-value="filter.selected"
            @update:model-value="handleFilterUpdate(code, $event!)"
          />
        </vf-dropdown>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { FiltersMap } from '#types/filters'

const props = defineProps<{
  filters: FiltersMap
  currentReviewsCount: number
}>()

const emit = defineEmits<{
  'filter-by': []
  'open-filters-panel': []
  'update:filters': [filters: FiltersMap]
}>()

const { $t } = useNuxtApp()

const handleFilterUpdate = (code: string | number, selected: string[]) => {
  const updatedFilters = {
    ...props.filters,
    [code]: {
      ...props.filters[code],
      selected
    }
  }
  emit('update:filters', updatedFilters)
  emit('filter-by')
}

const openFiltersPanel = () => emit('open-filters-panel')
</script>
